module.exports = __webpack_public_path__ + "img/kingpin-logo-with-text.e1a2bdbf.svg";